import * as React from 'react';
import * as ReactDOM from 'react-dom';
import InClientStorePanel, { InClientStorePanelHandle } from '../components/InClientStorePanel';
import initializeStore from '../../lib/InitAddinStore';

let StorePaneContainer: HTMLDivElement;

StorePaneContainer = document.createElement('div');
document.body.appendChild(StorePaneContainer);

export default function openInClientStore() {
    initializeStore().then((storeUrl: string) => {
        const onRef = (ref: InClientStorePanelHandle) => !!ref && ref.setPanelOpen();

        ReactDOM.render(<InClientStorePanel storeUrl={storeUrl} ref={onRef} />, StorePaneContainer);
    });
}
